export const EMPLOYEE_COLUMN_WIDTHS = {
  lastName: '150px',
  firstName: '150px',
  ssn: '80px',
  employerEmployeeId: '100px',
  partnerEmployeeId: '100px',
} as const;

export const STATUS_COLUMN_WIDTH = '100px';
export const FRAUD_COLUMN_WIDTH = '24px';

export const FILTER_WIDTHS = {
  search: '180px',
  employer: '160px',
  subsidiary: '160px',
  status: '150px',
} as const;
